export default "__VITE_ASSET__52334a8e__"